import { feedbackCategories, ContactEntry } from "./ContactFormCategories";
import { fleet } from "./ContactFormEntities";

/** Retrieve category data to populate the dropdowns */
export const ContactFormData: ContactEntry[] = Object.keys(feedbackCategories).map((categoryName) => [{
    ...fleet,
    ...feedbackCategories[categoryName],
    section: feedbackCategories[categoryName].label
}]).reduce((a, b) => Array.prototype.concat(a, b)) as ContactEntry[];